export default "__VITE_ASSET__DvHzHO5h__"